import CardChartTotal from '@/components/ui/card-wrapper/CardChartTotal';
import ReactApexChart from 'react-apexcharts';
import dayjs from 'dayjs';
import { ApexOptions } from 'apexcharts';
import { shortEnglishHumanizer } from '@/utils/formatTime';
import { fNumber } from '@/utils/formatNumber';

interface ServerlessGpuOverviewMetricsUsagesProps {
  data: { date: number; total: number }[];
  sumTotal: number;
}

const ServerlessGpuOverviewMetricsUsages = ({
  data,
  sumTotal,
}: ServerlessGpuOverviewMetricsUsagesProps) => {
  const options: ApexOptions = {
    chart: {
      type: 'line',
      height: 250,
      toolbar: {
        show: true,
        tools: {
          download: false,
        },
      },
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    xaxis: {
      type: 'datetime',
      labels: {
        datetimeUTC: false,
      },
      tickAmount: 2,
    },
    yaxis: {
      decimalsInFloat: 0,
    },
    colors: ['hsl(var(--success))'],
    legend: {
      markers: {
        shape: 'circle',
        size: 12,
      },
      position: 'bottom',
      horizontalAlign: 'center',
    },
    tooltip: {
      x: {
        formatter: (value: number) => dayjs(value).format('DD MMM, HH:mm'),
      },
      y: {
        formatter: (value: number) => `${fNumber(value)} s`,
      },
    },
  };

  const series = [
    {
      name: 'Usage',
      data: data.map((item) => [item.date, item.total]),
    },
  ];

  return (
    <CardChartTotal
      title="Endpoint Usages"
      description="Showing total endpoint usage for past 24 hours"
      total={
        shortEnglishHumanizer(sumTotal * 1000, {
          units: ['m', 's'],
          delimiter: ' ',
          maxDecimalPoints: 0,
        }) || '0'
      }
    >
      <div className="h-[250px] w-full">
        <ReactApexChart
          options={options}
          series={series}
          type="line"
          height={250}
        />
      </div>
    </CardChartTotal>
  );
};

export default ServerlessGpuOverviewMetricsUsages;
